import React, { Component } from "react";
import { generateGBGQRCode } from "../../action/gbg/generateGBGQRCode";
import { PropTypes } from 'prop-types';
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import { getIdvStatus } from "../../action/gbg/getIdvStatus";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
class GBGQrCode extends Component {
	constructor(props) {
		super(props);
		this.state = {
			qrImage: "",
			GbgSessionId: '',
			showRegenerateQrcode: false,
			disableRegenerateQrButton: false,
			isIntervalCreated: false,
			isGbgVerificationComplete: false,
			greater: false
		};
		this.timeoutId = null;
		this.gbgInterval = null;
		this.gbgEventSource = null;
	}

	componentDidMount() {
		this.props.handleLoader(true);
		this.generateQRCode();
	}

	componentWillUnmount() {
		clearTimeout(this.timeoutId);
	}

	generateQRCode = async () => {
		try {
			const applicationId = new URLSearchParams(window.location.search).get("applicationID") || sessionStorage.getItem("applicationId") || '';
			const response = await generateGBGQRCode({ applicationId });
			if (response?.data.status_code === 200 && response?.data?.data.qr_code && response?.data?.data.url) {
				analyticsClickEvent('gbg_qr_code_generated_success', 'GBG');
				this.setState({ qrImage: `data:image/png;base64,${response?.data?.data.qr_code}` ,GbgSessionId:response?.data?.session_id,showRegenerateQrcode:false});
				this.props.onGBGQRCodeGenerated(true, response?.data?.data.url);
				this.getQrStatus(response?.data?.data?.session_id);
				if (!this.state.isIntervalCreated) {
					this.getGbgApplicationStatus();
				}
			} else {
				analyticsClickEvent('gbg_qr_code_generation_failed', 'GBG');
				this.props.onGBGQRCodeGenerated(false);
			}
		} catch (error) {
			analyticsClickEvent('gbg_qr_code_generation_failed', 'GBG');
			console.error("GBG QR Code generation failed:", error);
			this.props.onGBGQRCodeGenerated(false);
		} finally {
			this.props.handleLoader(false);
		}
	};

	getGbgApplicationStatus = async () => {
		this.gbgInterval = setInterval(this.fetchGbgStatus, 30000);
		this.setState({ isIntervalCreated: true });
	}

	fetchGbgStatus = async () => {
		const applicationId = sessionStorage.getItem('applicationId') || '';
		const { isGbgVerificationComplete, greater } = this.state;
		if (isGbgVerificationComplete) {
			this.setState({ greater: true });
			clearInterval(this.gbgInterval);
			return;
		}
		if (greater) {
			return;
		}
		try {
			const gbgResponse = await getIdvStatus({ applicationExternalId: applicationId });
			if (!gbgResponse?.data) {
				frontEndLogs('Invalid response from getIdvStatus API', false, 400, 'fetchGbgStatus');
				return;
			}
			if (!gbgResponse.data?.data?.isGbgVerificationComplete) {
				return;
			}
			await this.handleGbgResult(gbgResponse);
			this.setState({
				isGbgVerificationComplete: true
			});
		} catch (error) {
			frontEndLogs('Error while fetching GBG status', false, 500, 'fetchGbgStatus', error);
		}
	};

	handleGbgResult = async (gbgResponse) => {
		if (gbgResponse?.data?.status_code === 202) {
			frontEndLogs('GBG Final Status Web - Application Approved | Application ID: ' + sessionStorage.getItem('applicationId'), false, 200, 'handleGbgResult', gbgResponse);
			analyticsClickEvent('gbg_application_approved_web', '');
			this.props.handleGbgStateUpdate(gbgResponse);
			return this.props.checkRedirectionBasedOnApplicationSubmitResponse(gbgResponse);
		}
		else if (gbgResponse?.data?.status_code === 200) {
			analyticsClickEvent('gbg_application_referred_web', '');
			frontEndLogs('GBG Final Status Web - Application Referred | Application ID: ' + sessionStorage.getItem('applicationId'), false, 200, 'handleGbgResult', gbgResponse);
			this.props.handleGbgStateUpdate(gbgResponse);
			this.props.checkIfButtonLabelAndRedirectUrLExists(gbgResponse?.data?.data);
			window.$('#commonModel').modal('show');
			window.$('#commonModel').modal({ backdrop: 'static', keyboard: false });
			return false;
		}
		else if (gbgResponse?.data?.status_code === 404) {
			analyticsClickEvent('gbg_application_Background Processing Exception', '');
			frontEndLogs('GBG Final Status Web - Background Processing Exception | Application ID: ' + sessionStorage.getItem('applicationId'), false, 200, 'handleGbgResult', gbgResponse);
			this.props.handleGbgStateUpdate(gbgResponse);
			window.$('#commonModel').modal('show');
			window.$('#commonModel').modal({ backdrop: 'static', keyboard: false });
			return false;
		}
		else {
			frontEndLogs('GBG Final Status Web - Other | Application ID: ' + sessionStorage.getItem('applicationId'), false, 200, 'handleGbgResult', gbgResponse);
			analyticsClickEvent('gbg_application_other_status_web', '');
			this.props.handleGbgStateUpdate(gbgResponse);
			window.$('#commonModel').modal('show');
			return false;
		}
	}

	getQrStatus = async (GbgSessionId) => {
		if (this.props.width > 768) {
			this.timeoutId = setTimeout(() => {
				this.closeGbgConnection();
				this.setState({
					showRegenerateQrcode: true,
					disableRegenerateQrButton: false
				});
			}, 120000);
			this.checkGbgStatus(GbgSessionId);
		}
	}

	checkGbgStatus = async (GbgSessionId) => {

		try {
			const eventSource = new EventSource(`https://identify.idscan.cloud/APIHandler/status-update?sessionId=${GbgSessionId}`);

			this.gbgEventSource = eventSource;

			eventSource.onmessage = async (event) => {
				try {
					const parsedData = JSON.parse(event.data);

					if (parsedData?.result !== "None") {
						this.setState({
							showRegenerateQrcode: true,
							disableRegenerateQrButton: false
						});
						this.closeGbgConnection();
					}
				} catch (error) {
					await frontEndLogs('Invalid JSON response', false, 400, 'checkGbgStatus', error?.message);
				}
			};

			eventSource.onerror = async (error) => {
				eventSource.close();
				await frontEndLogs('EventSource error', false, 400, 'checkGbgStatus', error?.message);
			};
		} catch (error) {
			await frontEndLogs('Error Initialise Qr Status stream', false, 400, 'checkGbgStatus', error?.message);
		}
	};

	closeGbgConnection = () => {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
		if (this.gbgEventSource) {
			this.gbgEventSource.close();
			this.gbgEventSource = null;
		}
	};

	render() {
		return (
			<>
				{this.state.qrImage === "" && (
					<div className="step-two-section text-center">
						<button type="button" className="btn btn-primary" onClick={() => { this.generateQRCode(); analyticsClickEvent('gbg_generate_qr_code', 'GBG'); }} >
							Generate QR Code
						</button>
					</div>
				)}

				{this.state.qrImage !== "" && (
					<>
						{(this.state.showRegenerateQrcode || this.props.isAlreadyApprovedApplication) && (
							<div className="step-two-section text-center">
								<button type="button" className="btn btn-primary" disabled={this.state.disableRegenerateQrButton} onClick={() => { this.generateQRCode(); this.setState({ disableRegenerateQrButton: true }); analyticsClickEvent('gbg_regenerate_qr_code', 'GBG'); }} >
									Regenerate QR Code
								</button>
							</div>)
						}
						{(!this.state.showRegenerateQrcode && !this.props.isAlreadyApprovedApplication) && (
							<img src={this.state.qrImage} alt="GBG QR" width="230" height="230" />)
						}
					</>
				)}
			</>
		);
	}
}

GBGQrCode.propTypes = {
	handleLoader: PropTypes.func,
}

export default GBGQrCode;
